function HotelTrialBalanceReport() {
    return (
      <>
        <div className="font-bold text-lg mb-16">HotelTrialBalanceReport</div>
      </>
    );
  }
  
  export default HotelTrialBalanceReport;